import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

const common = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

export function SearchIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...common} {...props}><circle cx="11" cy="11" r="6.8"/><path d="m16.1 16.1 4.2 4.2"/></svg>
}

export function UserIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...common} {...props}><circle cx="12" cy="8" r="3.3"/><path d="M5.5 20c.7-4 3-6 6.5-6s5.8 2 6.5 6"/></svg>
}

export function BagIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...common} {...props}><path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/></svg>
}

export function ArrowIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...common} {...props}><path d="M5 12h13"/><path d="m14 7 5 5-5 5"/></svg>
}

export function MenuIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...common} {...props}><path d="M4 7h16M4 12h16M4 17h16"/></svg>
}

export function CloseIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...common} {...props}><path d="m6 6 12 12M18 6 6 18"/></svg>
}
